import { useMutation, useQueryClient } from 'react-query'
import packagingApi from './actions'
import { packagingKeys } from './constants'

const usePackagingTypesMutations = (companyId: number) => {
  const queryClient = useQueryClient()

  const createPackagingType = useMutation(packagingApi.createPackagingType, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(packagingKeys.root(companyId))
    },
  })

  const updatePackagingType = useMutation(packagingApi.updatePackagingType, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(packagingKeys.root(companyId))
    },
  })

  const deletePackagingType = useMutation(packagingApi.deletePackagingType, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(packagingKeys.root(companyId))
    },
  })

  return { createPackagingType, updatePackagingType, deletePackagingType }
}

export default usePackagingTypesMutations
